import * as signalR from '@microsoft/signalr';

const hubUrl =
    process.env.NODE_ENV === 'development'
        ? "https://localhost:7022/notificationHub"
        : "/notificationHub";

let connection = null;

export function getNotificationHubConnection() {
    if (!connection) {
        connection = new signalR.HubConnectionBuilder()
            .withUrl(hubUrl, { withCredentials: true })
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Information)
            .build();
    }
    return connection;
}

export async function startConnection() {
    const conn = getNotificationHubConnection();
    if (conn.state === signalR.HubConnectionState.Disconnected) {
        try {
            await conn.start();
            console.log(`Connected to SignalR hub at ${hubUrl}`);
        } catch (err) {
            console.error("SignalR Connection Error: ", err);
        }
    }
    return conn;
}

export async function startChatConnection(onReceiveChunk) {
    const conn = getNotificationHubConnection();

    if (conn.state === signalR.HubConnectionState.Disconnected) {
        await conn.start();
    }

    conn.off("ReceiveChatChunk"); // prevent duplicate handlers
    conn.on("ReceiveChatChunk", ({ sessionId, chunk, messageId }) => {
        onReceiveChunk(sessionId, chunk, messageId);
    });

    return conn;
}

